import { createFileRoute } from '@tanstack/react-router'
import { SobreviventeGamePage } from '@/features/sobrevivente/components/SobreviventeGamePage'

export const Route = createFileRoute('/_authenticated/sobrevivente/$gameId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    gw: typeof search.gw === 'string' ? search.gw : undefined,
  }),
  component: SobreviventeGame,
})

function SobreviventeGame() {
  const { gameId } = Route.useParams()
  const { gw }     = Route.useSearch()
  return <SobreviventeGamePage gameId={gameId} gw={gw} />
}
